
const {
  isDev,
} = require('./utils')

function encodeURIComponentForApple(component) {
  // iOS is non-standard as usual, and for some reason only accepts the encodeURI encoded characters AND the equals character
  return encodeURI(component).replace(/=/g, '%3D')
}

/**
 * Makes a link compatible with Firebase dynamic links for iOS and Android.
 * 
 * @param {string} linkUrl - The URL to open in the mobile app
 * @param {string} options.androidFallbackUrl - The URL to open if app isn't installed on Android; default is play store link
 * @param {string} options.iosFallbackUrl - The URL to open if app isn't installed on iOS; default is app store link
 * @param {string} options.fallbackUrl - The URL to open on platforms other than Android & iOS; default is linkUrl
 * @param {boolean} options.fallbackToGooglePlay - Sets `fallbackUrl` to the play store link
 * @param {boolean} options.fallbackToAppStore - Sets `fallbackUrl` to the app store link
 */
exports.makeReachDynamicLink = function(linkUrl, options = {}) {
  const {
    dynamicLinkSubdomain = 'open',
    androidFallbackUrl,
    iosFallbackUrl,
    fallbackUrl,
    fallbackToGooglePlay = false,
    fallbackToAppStore = false,
    analytics: {
      source = 'reach',
      campaign = 'dl',
      medium = 'web',
    } = {},
  } = options

  const bundleId = isDev ? 'co.v2media.d42' : 'co.v2media.p42'
  const appStoreId = isDev ? '1606971374' : '1606971549'

  let result = `https://${dynamicLinkSubdomain}.${isDev ? 'reach-dev.me' : 'reach.me'}/?link=${encodeURIComponentForApple(linkUrl)}&apn=${bundleId}&isi=${appStoreId}&ibi=${bundleId}`

  if (androidFallbackUrl) {
    result += `&afl=${encodeURIComponent(androidFallbackUrl)}`
  }
  if (iosFallbackUrl) {
    result += `&ifl=${encodeURIComponent(iosFallbackUrl)}`
  }

  if (fallbackUrl) {
    result += `&ofl=${encodeURIComponent(fallbackUrl)}`
  } else if (fallbackToGooglePlay) {
    result += `&ofl=${encodeURIComponent('https://play.google.com/store/apps/details?id=co.v2media.p42')}`
  } else if (fallbackToAppStore) {
    result += `&ofl=${encodeURIComponent('https://apps.apple.com/us/app/reach-for-creators/id1606971549')}`
  }

  if (source) {
    result += `&utm_source=${source}`
  }
  if (campaign) {
    result += `&utm_campaign=${campaign}`
  }
  if (medium) {
    result += `&utm_medium=${medium}`
  }

  return result
}
